import { omit } from "remeda";
import { SelfCare } from "modules/selfcare/schemas/selfcareApiSchemas";

const getFormValuesFromUserProfile = (user: SelfCare) =>
  omit(user, ["id", "regions", "roles", "routes", "test_cards"]);

export default getFormValuesFromUserProfile;
